"use strict";
// NOTE: Copy from https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionsWithPassive = exports.isPassiveSupported = void 0;
exports.isPassiveSupported = false;
try {
    const options = {
        get passive() {
            // This function will be called when the browser
            //   attempts to access the passive property.
            exports.isPassiveSupported = true;
            return false;
        },
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.addEventListener('test', null, options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.removeEventListener('test', null, options);
}
catch (err) {
    exports.isPassiveSupported = false;
}
exports.optionsWithPassive = exports.isPassiveSupported ? { passive: true } : false;
//# sourceMappingURL=passive.js.map